import {Subscription} from 'rxjs';
import {StreamDataService} from '../../../envisia/main/stream/stream-data.service';
import {PriceDebugMessage} from '../../../envisia/main/stream/stream.model';

export class PriceDebugMessageStore {
  private listeners = new Set<() => void>();
  private subscriptions: Subscription[] = [];
  private snapshot: PriceDebugMessage[][] = [];

  constructor(private streamDataService: StreamDataService) {
  }

  readonly subscribe = (listener: () => void): (() => void) => {
    if (this.listeners.size === 0) {
      this.connect();
    }
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
      if (this.listeners.size === 0) {
        this.disconnect();
      }
    };
  };

  readonly getSnapshot = (): PriceDebugMessage[][] => {
    return this.snapshot;
  };

  readonly clear = (): void => {
    this.snapshot = [];
    this.emit();
  };

  private append(messages: PriceDebugMessage[]): void {
    this.snapshot = [...this.snapshot, messages].slice(-20);
    this.emit();
  }

  private connect(): void {
    this.subscriptions = [
      this.streamDataService.subscribe('websocket.debug_event', (message: PriceDebugMessage) => {
        this.append([message]);
      }),
      this.streamDataService.subscribe('websocket.debug_event_batch', (batch: PriceDebugMessage[]) => {
        this.append(batch);
      }),
      this.streamDataService.subscribe('websocket.debug_event_clear', () => {
        this.clear();
      }),
    ];
  }

  private disconnect(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }

  private emit(): void {
    this.listeners.forEach(listener => listener());
  }
}
